// extracted by mini-css-extract-plugin
export var fadeIn = "Navigation-module--fadeIn--e076d";
export var fadeOut = "Navigation-module--fadeOut--bbab3";
export var header__mobileToggle = "Navigation-module--header__mobileToggle--fb9fa";
export var header__navLinks = "Navigation-module--header__navLinks--1e044";
export var header__navbar = "Navigation-module--header__navbar--09696";
export var header__navbarWrap = "Navigation-module--header__navbarWrap--1c693";